import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';


const LysterSelect = ({
  selectedOption, options, onSelect, style,
}) => (
  <Select
    style={style}
    value={selectedOption.value}
    onChange={(evt, { props: { value } }) => onSelect(value)}
    inputProps={{
      name: 'age',
      id: 'age-simple',
    }}
  >
    { options.map((o) => <MenuItem key={o.value} value={o.value}>{ o.label }</MenuItem>) }
  </Select>
);

export default LysterSelect;
